module.exports = __webpack_public_path__ + "static/media/500.2e51e361.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/500.png
// module id = 1728
// module chunks = 0